import React, { Suspense } from 'react';
import { Lazy } from '@root/src/web/components/Lazy';
import { isNPageOrHigherPageView, isValidContentType, isValidSection, isIOS9, } from '@frontend/web/components/SignInGate/displayRule';
import { initPerf } from '@root/src/web/browser/initPerf';
import { unsetUserDismissedGate } from '../dismissGate';
const SignInGateMain = React.lazy(() => {
    const { start, end } = initPerf('SignInGateMain');
    start();
    return import(
    /* webpackChunkName: "SignInGateMain" */ '../gateDesigns/SignInGateMain').then((module) => {
        end();
        return { default: module.SignInGateMain };
    });
});
const canShow = (CAPI, isSignedIn, currentTest) => {
    unsetUserDismissedGate(currentTest.variant, currentTest.name); // clears gate dismissal from local storage
    return (
    // do not check for gate dismissal as gate should show on every article
    !isSignedIn &&
        isNPageOrHigherPageView(3) &&
        isValidContentType(CAPI) &&
        isValidSection(CAPI) &&
        !isIOS9());
};
export const signInGateComponent = {
    gate: ({ ophanComponentId, dismissGate, guUrl, signInUrl, abTest, isComment, }) => (React.createElement(Lazy, { margin: 300 },
        React.createElement(Suspense, { fallback: React.createElement(React.Fragment, null) },
            React.createElement(SignInGateMain, { ophanComponentId: ophanComponentId, dismissGate: dismissGate, guUrl: guUrl, signInUrl: signInUrl, abTest: abTest, isComment: isComment })))),
    canShow,
};
